/* eslint-disable max-len */
import { NavLink } from 'react-router';

import { UikitMenuSidebar } from '../../components/UikitMenuSidebar';
import { UikitMenu } from '../../components/UikitMenu';
import { routes } from '../../routes';
import { NewBadge } from '../components/ComponentsMenu';

const BASE_URL = `/${routes.TEMPLATES}`;
const title = 'Templates';

const navLinkClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : undefined);

export const getUiTemplatesMenuItems = () => {
    const menu = [
        {
            group: 'Content',
            navItems: [
                {
                    key: 'featureCards',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/feature-cards`}>
                            Feature cards
                        </NavLink>
                    ),
                    meta: 'action panels feature cards template',
                },
                {
                    key: 'aiAssistant',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/ai-assistant`}>
                            AI Assistant
                        </NavLink>
                    ),
                    meta: 'ai assistant query response service data template',
                },
                {
                    key: 'detailViews',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/detail-views`}>
                            Detail views
                        </NavLink>
                    ),
                    meta: 'details views blocks template',
                },
                {
                    key: 'expandableDetails',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/expandable-details`}>
                            Expandable details
                        </NavLink>
                    ),
                    meta: 'expandable details blocks template',
                },
                {
                    key: 'lists',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/list-blocks`}>
                            List blocks
                        </NavLink>
                    ),
                    meta: 'lists blocks template',
                },
                {
                    key: 'panelVariants',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/panel-variants`}>
                            Panel variants
                        </NavLink>
                    ),
                    meta: 'panel variants blocks template',
                },
                {
                    key: 'performanceOverview',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/performance-overview`}>
                            Performance overview <NewBadge />
                        </NavLink>
                    ),
                    meta: 'performance overview dashboard metrics chart activity template',
                },
                {
                    key: 'timelinePatterns',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/timeline-patterns`}>
                            Timeline patterns
                        </NavLink>
                    ),
                    meta: 'timeline patterns logistics shipment route stops process milestones template',
                },
                {
                    key: 'optionsPanel',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/options-panel`}>
                            Options panel
                        </NavLink>
                    ),
                    meta: 'options panel template',
                },
                {
                    key: 'technicalSetup',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/technical-setup`}>
                            Technical setup
                        </NavLink>
                    ),
                    meta: 'technical setup administration code keys copy command line radio card template',
                },
                {
                    key: 'usageCards',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/usage-cards`}>
                            Usage cards
                        </NavLink>
                    ),
                    meta: 'usage cards template',
                },
                {
                    key: 'stats',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/stats-blocks`}>
                            Stats blocks
                        </NavLink>
                    ),
                    meta: 'stats summary blocks template',
                },
            ],
        },
        {
            group: 'Forms',
            navItems: [
                {
                    key: 'settingsForm',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/settings-form`}>
                            Settings form
                        </NavLink>
                    ),
                    meta: 'settings forms template',
                },
                {
                    key: 'formToggle',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/form-toggle`}>
                            Form toggle
                        </NavLink>
                    ),
                    meta: 'forms toggle template',
                },
                {
                    key: 'formSummary',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/form-summary`}>
                            Form summary
                        </NavLink>
                    ),
                    meta: 'forms summary template',
                },
            ],
        },
        {
            group: 'Progress',
            navItems: [
                {
                    key: 'loadingProgress',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/loading-progress`}>
                            Loading progress
                        </NavLink>
                    ),
                    meta: 'loading progressbar template',
                },
                {
                    key: 'progressCards',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/progress-cards`}>
                            Progress cards
                        </NavLink>
                    ),
                    meta: 'progress cards template',
                },
                {
                    key: 'progressSuccess',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/progress-success`}>
                            Progress success
                        </NavLink>
                    ),
                    meta: 'progress success template',
                },
            ],
        },
        {
            group: 'Tables',
            navItems: [
                {
                    key: 'commonTable',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/common-table`}>
                            Common table
                        </NavLink>
                    ),
                    meta: 'basic common table template',
                },
                {
                    key: 'tablePanel',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/table-panel`}>
                            Table panel
                        </NavLink>
                    ),
                    meta: 'table expand panel combined tables in ExpandablePanel template',
                },
            ],
        },
    ];

    return menu.map(item => ({ ...item, badge: title }));
};

export const UITemplatesMenu = () => (
    <UikitMenuSidebar title={title}>
        <UikitMenu />
    </UikitMenuSidebar>
);
